import { Fragment } from 'react'
import { Avatar } from '@mui/material'
import { BaseGridLayout, sx } from '@lucan/base-ui'

export default function TitoloTab(props) {
  const { Icona, numero, titolo, propsIcona, propsNumero, disabled, ...rest } = props

  return (
    <BaseGridLayout alignCenter spacing={1} {...rest}>
      {Icona &&
        <Icona
          key='icona'
          fontSize='small'
          color='default'
          {...propsIcona}
          {...sx(propsIcona, { mt: 0.5 })}
        />
      }
      {numero &&
        <Avatar
          key='numero'
          {...propsNumero}
          {...sx(propsNumero, { 
            width: 20, height: 20, fontSize: 12, 
            bgcolor: disabled ? 'default.main' : 'primary.main'
          })}
        >
          {numero}
        </Avatar>
      }
      <Fragment key='testo'>{titolo}</Fragment>
    </BaseGridLayout>
  )
}